import { render, staticRenderFns } from "./comparisonTableMixedSegments.vue?vue&type=template&id=3318909c&scoped=true"
import script from "./comparisonTableMixedSegments.vue?vue&type=script&lang=js"
export * from "./comparisonTableMixedSegments.vue?vue&type=script&lang=js"
import style0 from "./comparisonTableMixedSegments.vue?vue&type=style&index=0&id=3318909c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318909c",
  null
  
)

export default component.exports